// extracted by mini-css-extract-plugin
module.exports = {"sponsorship_text":"SponsorshipText_sponsorship_text__BpBXP"};